import type { CSSProperties } from 'react';

export interface SkeletonProps {
    width?: number | string;
    height?: number | string;
    radius?: number;
    /** Quantidade de barras. A última sai mais curta, imitando fim de parágrafo. */
    lines?: number;
    style?: CSSProperties;
}

export function Skeleton({ width = '100%', height = 12, radius = 6, lines = 1, style }: SkeletonProps) {
    const bar = (i: number) => (
        <span
            key={i}
            style={{
                display: 'block', width: lines > 1 && i === lines - 1 ? '62%' : width, height,
                borderRadius: radius,
                background: 'linear-gradient(90deg,var(--neutral-75) 25%,var(--neutral-100) 37%,var(--neutral-75) 63%)',
                backgroundSize: '400% 100%', animation: 'vec-shimmer 1.4s ease infinite',
            }}
        />
    );
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, ...style }}>
            {Array.from({ length: lines }, (_, i) => bar(i))}
            <style>{'@keyframes vec-shimmer{0%{background-position:100% 50%}100%{background-position:0 50%}}'}</style>
        </div>
    );
}
